module.exports = __webpack_public_path__ + "static/290-years-fc5d0bac4dd161c9ff9ddcdf12d95118.svg";